import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const ServiceRow = ({ service, index, flip }) => (
  <Reveal>
    <article data-testid={`service-${service.slug}`} className="grid items-center gap-8 lg:grid-cols-12 lg:gap-16">
      <div className={`lg:col-span-5 ${flip ? "lg:order-2" : ""}`}>
        <div className="overflow-hidden rounded-2xl border border-border">
          <img src={service.image} alt={service.title} className="aspect-[4/3] w-full object-cover" loading="lazy" />
        </div>
      </div>
      <div className={`lg:col-span-7 ${flip ? "lg:order-1 lg:pr-8" : "lg:pl-8"}`}>
        <p className="font-display text-sm text-accent">{String(index).padStart(2, "0")}</p>
        <h3 className="mt-3 font-display text-2xl font-light leading-tight text-foreground sm:text-3xl">{service.title}</h3>
        <p className="mt-5 text-base font-light leading-relaxed text-muted-foreground">{service.description}</p>
        <ul className="mt-6 grid gap-3 sm:grid-cols-3">
          {service.points.map((p) => (
            <li key={p} className="flex items-start gap-2 text-sm text-foreground/80">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" strokeWidth={2} /> {p}
            </li>
          ))}
        </ul>
        <Link
          to={`/contact?service=${service.slug}`}
          data-testid={`service-cta-${service.slug}`}
          className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-primary transition-colors hover:text-accent"
        >
          Inquire about this service <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </article>
  </Reveal>
);
